import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20of%20contemporary%20fashion%20accessories%20sneakers%20hoodie%20and%20lifestyle%20items%20arranged%20creatively%20on%20warm%20oatmeal%20textured%20surface%20with%20soft%20diffused%20natural%20light%20minimal%20elegant%20composition%20with%20generous%20copy%20space%20and%20subtle%20organic%20shadows%20editorial%20product%20photography&width=1800&height=900&seq=hero-main-v2-001&orientation=landscape&nocache=true"
          alt="OOPBuy Spreadsheet Produkte"
          className="w-full h-full object-cover"
          title="OOPBuy Spreadsheet Deutschland – Beste Produkte 2026"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/60 via-background-950/30 to-background-950/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full mx-auto max-w-[1440px] px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-500 text-xs font-medium mb-6 backdrop-blur-sm border border-accent-500/30">
            OOPBuy Spreadsheet 2026
          </span>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.05] mb-6">
            <span className="block">{t('hero.title.line1')}</span>
            <span className="block text-accent-300">{t('hero.title.line2')}</span>
            <span className="block">{t('hero.title.line3')}</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-lg leading-relaxed mb-8">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-400 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 group"
            >
              {t('hero.cta')}
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm text-background-50 text-sm font-semibold hover:bg-background-50/20 border border-background-50/30 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              {t('hero.cta2')}
              <i className="ri-shopping-cart-line"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}